export const getPhoneNumberWithoutDDD = (phoneNumber: string): string =>
  String(phoneNumber).slice(2);
